import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.carsaledoc.com";

export default function SEO({
  title,
  description,
  path = "/",
  noindex = false,
  jsonLd = null,
  ogImage = "/og-default.png",
}) {
  const fullTitle = title;
  const canonical = `${SITE_URL}${path}`;
  // Google truncates titles around 60 chars and descriptions around 160 chars
  // in SERPs. We hard-cap here so even pages that pass through unusual data
  // get clean snippets. The cap is applied with a 3-char ellipsis fallback so
  // we never cut in the middle of a word: trim at the last space before 158.
  const truncatedDescription = (() => {
    if (!description) return "";
    if (description.length <= 158) return description;
    const cut = description.slice(0, 158);
    const lastSpace = cut.lastIndexOf(" ");
    return (lastSpace > 130 ? cut.slice(0, lastSpace) : cut) + "…";
  })();
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={truncatedDescription} />
      <link rel="canonical" href={canonical} />
      {noindex ? (
        <meta name="robots" content="noindex,nofollow" />
      ) : (
        <meta name="robots" content="index,follow" />
      )}

      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={truncatedDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="CarSaleDoc" />
      <meta property="og:image" content={`${SITE_URL}${ogImage}`} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={truncatedDescription} />
      <meta name="twitter:image" content={`${SITE_URL}${ogImage}`} />

      {jsonLd && (
        Array.isArray(jsonLd) ? (
          jsonLd.map((ld, i) => (
            <script key={i} type="application/ld+json">
              {JSON.stringify(ld)}
            </script>
          ))
        ) : (
          <script type="application/ld+json">
            {JSON.stringify(jsonLd)}
          </script>
        )
      )}
    </Helmet>
  );
}
